export const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL ||
  (process.env.NODE_ENV === "production" ? "https://backend-superpizza.onrender.com" : "http://127.0.0.1:8000")).replace(/\/$/, "");
export const API_BASE = `${BACKEND_URL}/api`;
export const ORDERS_WS = `${BACKEND_URL.replace(/^http/, "ws")}/api/ws/orders`;
